const DPILevels = {
  Minimum: 100,
  Recommended: 200
};

function parseDpi(photoDpi) {
  return Math.round(parseFloat(photoDpi));
}

function aboveRecommendedDpi(photoDpi) {
  const dpi = parseDpi(photoDpi);

  if (Number.isNaN(dpi)) {
    return undefined;
  }

  return dpi >= DPILevels.Recommended;
}

function aboveMinimumDpi(photoDpi) {
  const dpi = parseDpi(photoDpi);

  if (Number.isNaN(dpi)) {
    return undefined;
  }

  return dpi >= DPILevels.Minimum;
}

export {
  aboveRecommendedDpi,
  aboveMinimumDpi
}
